import { render, staticRenderFns } from "./previewWxpay.vue?vue&type=template&id=0de35348&scoped=true&lang=html&"
import script from "./previewWxpay.vue?vue&type=script&lang=js&"
export * from "./previewWxpay.vue?vue&type=script&lang=js&"
import style0 from "./previewWxpay.vue?vue&type=style&index=0&id=0de35348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de35348",
  null
  
)

export default component.exports